import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';
import { MediaInput } from '../../components/inputs/MediaInput';

export const CollectionCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput 
          source="name" 
          label="Название" 
          validate={[required()]} 
          fullWidth 
        />
        <TextInput 
          source="slug" 
          label="URL (slug)" 
          helperText="Оставьте пустым для автоматической генерации"
          fullWidth 
        />
        <TextInput 
          source="description" 
          label="Описание" 
          multiline 
          rows={4} 
          fullWidth 
        />
        <MediaInput 
          source="imageId" 
          label="Изображение" 
          accept="image/*"
          helperText="Выберите изображение для коллекции"
        />
        <NumberInput 
          source="sortOrder" 
          label="Порядок сортировки" 
          defaultValue={0} 
        />
        <BooleanInput 
          source="isActive" 
          label="Активна" 
          defaultValue={true} 
        />
      </FormTab>
      
      <FormTab label="Товары">
        <ArrayInput source="products" label="Товары в подборке">
          <SimpleFormIterator>
            <ReferenceInput 
              source="productId" 
              reference="products" 
              label="Товар"
            >
              <SelectInput 
                optionText="name" 
                optionValue="id" 
                fullWidth 
              />
            </ReferenceInput>
            <MediaInput 
              source="customImageId" 
              label="Кастомное изображение" 
              accept="image/*"
              helperText="Выберите изображение для товара в коллекции"
            />
            <NumberInput 
              source="sortOrder" 
              label="Порядок" 
              defaultValue={0} 
            />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
      
      <FormTab label="SEO">
        <TextInput 
          source="metaTitle" 
          label="Meta Title" 
          fullWidth 
        />
        <TextInput 
          source="metaDescription" 
          label="Meta Description" 
          multiline 
          rows={3} 
          fullWidth 
        />
        <TextInput 
          source="metaKeywords" 
          label="Meta Keywords" 
          fullWidth 
        />
      </FormTab>
    </TabbedForm>
  </Create>
);
